module.exports = __webpack_public_path__ + "static/media/logo.a7f26416.png";